import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tagActions from '../../../../../../actions/tagAction';
import TagGroupDetailItem from './TagGroupDetailItem';

const mapStateToProps = state => {
  return {
    tagGroupDetailState: state.tagGroupDetailReducer,
    tagGroupState: state.tagGroupReducer,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTagGroupDetailItem: (id) => dispatch(tagActions.getTagGroupDetailItem(id)),
    getAllTagGroup: () => dispatch(tagActions.getAllTagGroup()),
    setTagGroupDetailItem: (tagGroupDetail) => dispatch(tagActions.setTagGroupDetailItem(tagGroupDetail)),
    updateTagGroupDetailItem: (tagGroupDetail, callbacks) => dispatch(tagActions.updateTagGroupDetail(tagGroupDetail, callbacks)),
    createTagGroupDetailItem: (tagGroupDetail) => dispatch(tagActions.createTagGroupDetail(tagGroupDetail)),
    createTagGroupDetailItemTranslate: (tagGroupDetail, language) => dispatch(tagActions.createTagGroupDetailTranslate(tagGroupDetail, language)),
    updateTagGroupDetailItemTranslate: (tagGroupDetail, language) => dispatch(tagActions.updateTagGroupDetailTranslate(tagGroupDetail, language)),
    deleteTagGroupDetailItemTranslate: (tagGroupDetail, refreshParams) => dispatch(tagActions.deleteTagGroupDetailTranslate(tagGroupDetail, refreshParams)),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TagGroupDetailItem));
